import { render, staticRenderFns } from "./CommentComponent.vue?vue&type=template&id=28714b1d&scoped=true&"
import script from "./CommentComponent.vue?vue&type=script&lang=js&"
export * from "./CommentComponent.vue?vue&type=script&lang=js&"
import style0 from "./CommentComponent.vue?vue&type=style&index=0&id=28714b1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28714b1d",
  null
  
)

export default component.exports